import { render } from "./HelpModal.vue?vue&type=template&id=2528f188&scoped=true"
import script from "./HelpModal?vue&type=script&lang=js"
export * from "./HelpModal?vue&type=script&lang=js"

import "./HelpModal.vue?vue&type=style&index=0&id=2528f188&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2528f188"]])

export default __exports__